/* eslint-disable no-undef */
if (typeof globalThis === "undefined") {
  var globalThis = (function () {
    if (typeof self !== "undefined") {
      return self
    }
    if (typeof window !== "undefined") {
      return window
    }
    if (typeof global !== "undefined") {
      return global
    }
    throw new Error("globalThis is not defined")
  })()
}

// ESM shim for the browser (and Node 18+ which has global fetch).
export default function ponyfill() {
  return {
    fetch: globalThis.fetch?.bind(globalThis),
    Headers: globalThis.Headers,
    Request: globalThis.Request,
    Response: globalThis.Response,
  }
}
